import React, { useMemo, useState, useEffect, useRef } from "react"
import CustomLink from "./CustomLink"
import { setNonDispalyValue, tableLinkColumn } from "./EventHandler"

const CustomPQRView = (props) => {
   const [changeOccure, setChangeOccure] = useState(false)
   const [partName] = useState(props.partName)

   useEffect(() => {
      if (changeOccure) {
         const delay = setTimeout(() => {
            props.handleDiffCategory(props.name);
         }, 1000); // Add a 1-second delay
   
         // Cleanup the timeout to avoid memory leaks
         return () => clearTimeout(delay);
      }
   }, [changeOccure, props.name, props.handleDiffCategory]);

   

   const [data, setData] = useState([]);
   const [previousData, setPreviousData] = useState([]);

   useEffect(() => {
      if (props.data) {
         setData(props.data);
      }
      if (props.previousData) {
         setPreviousData(props.previousData);
      }
   }, [props.data, props.previousData]);
   
   const containerRef = useRef(null);
   const table1Ref = useRef(null);
   const table2Ref = useRef(null);
   
   useEffect(() => {
      const synchronizeRowHeights = () => {

         const table1Header = table1Ref.current?.querySelector("thead");
         const table2Header = table2Ref.current?.querySelector("thead");

         if (table1Header && table2Header) {
            const table1HeaderCells = table1Header.querySelectorAll("th");
            const table2HeaderCells = table2Header.querySelectorAll("th");

            for (let i = 0; i < table1HeaderCells.length; i++) {
               const cell1 = table1HeaderCells[i];
               const cell2 = table2HeaderCells[i];

               if (cell1 && cell2) {
                  const maxWidth = Math.max(cell1.offsetWidth, cell2.offsetWidth);
                  cell1.style.width = `${maxWidth}px`;
                  cell2.style.width = `${maxWidth}px`;
               }
            }
         }

         const table1Rows = table1Ref.current?.querySelectorAll("tr") || [];
         const table2Rows = table2Ref.current?.querySelectorAll("tr") || [];
   
         // Ensure both tables have the same number of rows
         const rowCount = Math.min(table1Rows.length, table2Rows.length);
   
         for (let i = 0; i < rowCount; i++) {
            const table1Row = table1Rows[i];
            const table2Row = table2Rows[i];
   
            if (table1Row && table2Row) {
               // Get the maximum height of the two rows
               const maxHeight = Math.max(table1Row.offsetHeight, table2Row.offsetHeight);
   
               // Apply the maximum height to both rows
               table1Row.style.height = `${maxHeight}px`;
               table2Row.style.height = `${maxHeight}px`;
            }
         }
      };
   
      // Delay synchronization to ensure rows are rendered
      const timeout = setTimeout(() => {
         synchronizeRowHeights();
      }, 100); // 100ms delay
   
      // Synchronize row heights on window resize
      window.addEventListener("resize", synchronizeRowHeights);
   
      return () => {
         clearTimeout(timeout);
         window.removeEventListener("resize", synchronizeRowHeights);
      };
   }, [data, previousData]);

   useEffect(() => {
      let isSyncingTable1 = false;
      let isSyncingTable2 = false;
   
      const handleScrollTable1 = () => {
         if (isSyncingTable2) return; // Prevent circular updates
         isSyncingTable1 = true;
         if (table2Ref.current) {
            table2Ref.current.scrollTop = table1Ref.current.scrollTop;
            table2Ref.current.scrollLeft = table1Ref.current.scrollLeft;
         }
         isSyncingTable1 = false;
      };
   
      const handleScrollTable2 = () => {
         if (isSyncingTable1) return; // Prevent circular updates
         isSyncingTable2 = true;
         if (table1Ref.current) {
            table1Ref.current.scrollTop = table2Ref.current.scrollTop;
            table1Ref.current.scrollLeft = table2Ref.current.scrollLeft;
         }
         isSyncingTable2 = false;
      };
   
      const table1 = table1Ref.current;
      const table2 = table2Ref.current;
   
      if (table1) {
         table1.addEventListener("scroll", handleScrollTable1);
      }
   
      if (table2) {
         table2.addEventListener("scroll", handleScrollTable2);
      }
   
      return () => {
         if (table1) {
            table1.removeEventListener("scroll", handleScrollTable1);
         }
         if (table2) {
            table2.removeEventListener("scroll", handleScrollTable2);
         }
      };
   }, [table1Ref, table2Ref, data, previousData]);

     const compareObjects = (current, previous, parentKey = "") => {
      let differences = {};
   
      if (typeof current === "object" && current !== null && typeof previous === "object" && previous !== null) {
          // If both are objects, compare their keys recursively
          const keys = new Set([...Object.keys(current), ...Object.keys(previous)]);
          keys.forEach((key) => {
            if (key.toLowerCase() === "id" || key.toLowerCase() === "link") {
               return;
               }
              const newKey = parentKey ? `${parentKey}.${key}` : key; // Flatten the key
              Object.assign(differences, compareObjects(current[key], previous[key], newKey));
          });
      } else {
          // For primitive values, compare directly
          const flattenedKey = parentKey;
          differences[flattenedKey] = current === previous ? "same" : "different";
          
      }
   
      return differences;
   };

   const isObjectEmpty = (obj) => {
      return Object.values(obj).every((value) => {
          if (typeof value === "object" && value !== null) {
              return isObjectEmpty(value);
          }
          return !value; 
      });
  };

   const differencesInEachRow = (index) => {
      let differencesInRow = {};

      if (data[index] && previousData[index]) {

          if (!isObjectEmpty(data[index]) && !isObjectEmpty(previousData[index])) {
            differencesInRow = compareObjects(data[index], previousData[index]);
          }
      }
  
      return differencesInRow;
  };
      

   
   const useSortableData = (items, config = null) => {
      const [sortConfig, setSortConfig] = useState({key:"Name",direction:"ascending"})
      const sortedItems = useMemo(() => {
         let sortableItems = [...items]
         if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
               if (a[sortConfig.key] === b[sortConfig.key]) {
                  if (a["Revision"] < b["Revision"]) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (a["Revision"] > b["Revision"]) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  
                  return 0
               } else {
                  if (a[sortConfig.key] < b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (a[sortConfig.key] > b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  
                  return 0
               }
            })
         }
         return sortableItems
      }, [items, sortConfig])

      const requestSort = (key) => {
         let direction = "ascending"
         if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === "ascending"
         ) {
            direction = "descending"
         }
         setSortConfig({ key, direction })
      }
      return { item: sortedItems, requestSort, sortConfig }
   }

   const { item, requestSort, sortConfig } = useSortableData(props.data)

   const getClassNamesFor = (Name) => {
      if (!sortConfig) {
         return "fa fa-sort"
      } else if (sortConfig.key === Name) {
         if (sortConfig.direction === "ascending") {
            return "fa fa-caret-up"
         } else {
            return "fa fa-caret-down"
         }
      } else {
         return "fa fa-sort"
      }
   }

   const getHeader = () => {
      var keys = getKeys()
      return keys.map((key, index) => {
         if (setNonDispalyValue(key)) {
            return null
         }
         if (key === 'Name' && props.view !== 'supplier'){
            return (
               <th key={key} >
                  Name&nbsp;
                  <i
                  onClick={() => requestSort("Name")}
                  className={getClassNamesFor("Name")}
                  ></i>
               </th>
            )
         } 
         else
         {
            return (
               <th key={key}>
                  <span>{key}</span>
               </th>
            )
         }
         
      })
   }

   const getRowsData = (item) => {
      var items = item
      var keys = getKeys()
      let backgroundColor = ''
      return items.map((row, index) => {
         const isRowEmpty = (row) => {
            if (!row || typeof row !== "object") return true;
        
            return Object.values(row).every((value) => {
                if (Array.isArray(value)) {
                    return value.length === 0 || value.every((item) => isRowEmpty(item));
                } else if (typeof value === "object" && value !== null) {
                    return isRowEmpty(value);
                }
                return !value;
            });
        };

        if (isRowEmpty(row)) {
            // Render an empty row
            if(changeOccure == false){
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            return (
                <tr key={index}>
                    <td colSpan={keys.length} style={{ backgroundColor: '#ffcccc' }}>
                        
                    </td>
                </tr>
            );
        }

        let differencesInRow = differencesInEachRow(index)

        if (Object.values(differencesInRow).includes("different")){
             if(changeOccure == false){
                setChangeOccure(true)
                props.handleDiffCategory(props.name)
             }
          backgroundColor = '#ffcccc'
         } else {
             backgroundColor = 'white'
         }
         return (
            <tr key={index} style={{ backgroundColor: backgroundColor }}>
               <RenderRow key={index} data={row} keys={keys} differencesInRow={differencesInRow} />
            </tr>
         )
      })
   }

   const getKeys = function () {
      return Object.keys(data[0])
   }

   const getColumnKeys = function (columKeyInfo) {
      return Object.keys(columKeyInfo)
   }

   const RenderColumn = function (props) {
      return props.keys.map((key, index) => {
         if(props.childKeysWithStatus[key] === 'different'){
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span style={{color:"red", fontWeight: 'bold'}}>{props.data[key]}</span>
               </div>
            )
         }
         if (props.data[key] != null)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span>{props.data[key]}</span>
               </div>
            )
         else return null
      })
   }

   const RenderChildern = function (props) {
      var colKeys=[]
      colKeys = getColumnKeys(props.data[0])
      return props.data.map((row, index) => {
         return (
            <table key={index}>
               <tbody>
                  <tr>
                     <td>
                     <RenderSubRow key={index} data={row} keys={colKeys} childKeysWithStatus={props.childKeysWithStatus} />
                     </td>
                  </tr>
               </tbody>
            </table>
         )
      })
   }
   const RenderSubRow=(props) => {
      
      return props.keys.map((key,index)=>{
         if (
            props.data[key] &&
            typeof props.data[key] == "object" &&
            key.includes("AN")
         ) {
            let color = ''
            if (props.childKeysWithStatus["name"] === "different") {
               color = "red"
            }
            return(
               <div key={index}>
                     <span className="bomFontClass">{key}:</span>
                     <span>
                        {  props.data[key]["id"] &&
                           props.data[key]["id"].toLowerCase().trim() !== "no access" &&
                           props.data[key]["link"] ? (
                           <CustomLink
                              id={props.data[key]["id"]}
                              link={props.data[key]["link"]}
                              name={props.data[key]["name"]}
                              color={color}
                           />
                           ) : (
                              <span>{props.data[key]["name"]}</span>
                           )
                        }
                     </span>
               </div>
            )
         }
         else{
             if (props.childKeysWithStatus[key] === 'different'){
               return(
                  <div key={index}>
                     <span className="bomFontClass">{key}:</span>{" "}
                     <span style={{color:"red", fontWeight: 'bold'}}>{props.data[key]}</span>
                  </div>
               )
            }
            else if (props.data[key] != null)
            return(
               <div key={index}>
                     <span className="bomFontClass">{key}:</span>{" "}
                     <span>{props.data[key]}</span>
               </div>
            )
         }
      })

   }

   const getPCLinks = function (data, link, id, color) {
      var elements = data.map((value, index) => {
         if (
            link[index] &&
            link[index].trim() !== "" &&
            id[index] &&
            id[index].trim() !== "" &&
            id[index].toLowerCase().trim() !== "no access"
         ) {
            return (
               <React.Fragment key={index}>
                  <span>
                     <CustomLink
                        id={id[index].trim()}
                        link={link[index].trim()}
                        name={value}
                        color={color}
                     />
                  </span>
                  <br />
               </React.Fragment>
            )
         } else {
            return (
               <React.Fragment key={index}>
                  <span>{value}</span>
                  <br />
               </React.Fragment>
            )
         }
      })
      return elements
   }
   const RenderLinkColumn = function (props) {
      
      return props.keys.map((key, index) => {
         if (props.data[key] && key.toLowerCase() === "n") {
            let nameData = props.data[key] ? props.data[key].split("|") : []
            let nameLink = props.data["link"] ? props.data["link"].split("|") : []
            let nameId = props.data["id"] ? props.data["id"].split("|") : []
            let color = ''
            if (props.childKeysWithStatus[key] === "different") {
               color = "red"
            }
            
            let getnamelinks = getPCLinks(nameData, nameLink, nameId, color)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                  {getnamelinks}
               </div>
            )
         } else if (setNonDispalyValue(key)) {
            return null
         } else if(props.childKeysWithStatus[key] === 'different'){
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span style={{color:"red", fontWeight: 'bold'}}>{props.data[key]}</span>
               </div>
            )
         } else if (props.data[key] != null)
            return (
               
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span>{props.data[key]}</span>
               </div>
            )
         else return null
      })
   }

   const RenderRow = (props) => {
      var colKeys = []
      return props.keys.map((key, index) => {
         if (
            props.data[key] &&
            typeof props.data[key] == "object" &&
            key.includes("PQR Qualification Name (N)")
         ) {
            colKeys = getColumnKeys(props.data[key])
            const childKeysWithStatus = Object.keys(props.differencesInRow || {})
                .filter((diffKey) => diffKey.startsWith(`${key}.`)) // Match keys that start with the parent key
                .reduce((acc, diffKey) => {
                    const childKey = diffKey.split('.').pop(); // Extract the child key
                    acc[childKey] = props.differencesInRow[diffKey]; // Map child key to its status
                    return acc;
                }, {});
            return (
               <td key={index}>
                  <RenderLinkColumn
                     isbold={true}
                     id={props.data["id"]}
                     data={props.data[key]}
                     keys={colKeys}
                     childKeysWithStatus={childKeysWithStatus}
                  />
               </td>
            )
         } else if (
            key.toLowerCase() === "name" &&
            props.data["id"] &&
            props.data["id"].toLowerCase() !== "no access"
         ) {
            var name = props.data[key]
            let color = ''
            if (props.differencesInRow[key] === "different") {
               color = "red"
            }
            return tableLinkColumn(props.data["id"], props.data["link"], name, index, '', color)
         }
         else if (
            props.data[key] &&
            typeof props.data[key] == "object" &&
            key.includes("Allowed MEP Name (AN) Allowed MEP Title (AT) Allowed MEP Vendor (AV)")
         ) {
            const childKeysWithStatus = Object.keys(props.differencesInRow || {})
                .filter((diffKey) => diffKey.startsWith(`${key}.`)) // Match keys that start with the parent key
                .reduce((acc, diffKey) => {
                    const childKey = diffKey.split('.').pop(); // Extract the child key
                    acc[childKey] = props.differencesInRow[diffKey]; // Map child key to its status
                    return acc;
                }, {});
            return (
               <td key={index}>
                  <RenderChildern 
                     data={props.data[key]}
                     childKeysWithStatus={childKeysWithStatus}
                     />
               </td>
            )
         }
         if (props.data[key] && typeof props.data[key] == "object") {
            colKeys = getColumnKeys(props.data[key])
            const childKeysWithStatus = Object.keys(props.differencesInRow || {})
                .filter((diffKey) => diffKey.startsWith(`${key}.`)) // Match keys that start with the parent key
                .reduce((acc, diffKey) => {
                    const childKey = diffKey.split('.').pop(); // Extract the child key
                    acc[childKey] = props.differencesInRow[diffKey]; // Map child key to its status
                    return acc;
                }, {});
            return (
               <td key={index}>
                  <RenderColumn isbold={true} data={props.data[key]} keys={colKeys} childKeysWithStatus={childKeysWithStatus} />
               </td>
            )
         } else if (setNonDispalyValue(key)) {
            return null
         } else {
            if (props.differencesInRow[key] === 'different'){
               return (
                  <td key={index}>
                     <span style={{color:"red", fontWeight: 'bold'}}>{props.data[key]}</span>
                  </td>
               )
            }
            return <td key={index}>{props.data[key]}</td>
         }
      })
   }

   return (
      <div>
         {(!data || data.length === 0) && (!previousData || previousData.length === 0) ? (
            <div>No data available</div>
         ) : (
            <>
               <div ref={containerRef} style={{ display: "flex" }}>
                  <div
                     ref={table1Ref}
                     style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
                  >
                     {props.revision && props.revision !== "" && (
                        <div
                           style={{
                              position: "sticky",
                              top: "0",
                              backgroundColor: "#EEEEEE",
                              textAlign: "center",
                              fontWeight: "bold",
                           }}
                        >
                           {partName}{" "}{props.revision["releaseRevision"]}
                        </div>
                     )}
                     {data && data.length > 0 && (
                        <table className="tableBorder">
                           <thead>
                              <tr>
                                 <th
                                    style={{ backgroundColor: "white" }}
                                    colSpan={
                                       props.type && props.type === "PMP"
                                          ? props.view && props.view === "supplier"
                                             ? 9
                                             : 8
                                          : props.view && props.view === "supplier"
                                          ? 7
                                          : 6
                                    }
                                 ></th>
                                 {props.view && (
                                    <>
                                       <th style={{ backgroundColor: "white" }}>
                                          <span>PQR</span>
                                       </th>
                                    </>
                                 )}
                              </tr>
                              <tr style={{backgroundColor:"#eee"}}>{getHeader()}</tr>
                           </thead>
                           <tbody>{getRowsData(data)}</tbody>
                        </table>
                     )}
                  </div>
   
                  <div
                     ref={table2Ref}
                     style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
                  >
                     {props.revision && props.revision !== "" && (
                        <div
                           style={{
                              position: "sticky",
                              top: "0",
                              backgroundColor: "#EEEEEE",
                              textAlign: "center",
                              fontWeight: "bold",
                           }}
                        >
                           {partName}{" "}{props.revision["obsoleteRevision"]}
                        </div>
                     )}
                     {previousData && previousData.length > 0 && (
                        <table className="tableBorder">
                           <thead>
                              <tr>
                                 <th
                                    style={{ backgroundColor: "white" }}
                                    colSpan={
                                       props.type && props.type === "PMP"
                                          ? props.view && props.view === "supplier"
                                             ? 9
                                             : 8
                                          : props.view && props.view === "supplier"
                                          ? 7
                                          : 6
                                    }
                                 ></th>
                                 {props.view && (
                                    <>
                                       <th style={{ backgroundColor: "white" }}>
                                          <span>PQR</span>
                                       </th>
                                    </>
                                 )}
                              </tr>
                              <tr style={{backgroundColor:"#eee"}}>{getHeader()}</tr>
                           </thead>
                           <tbody>{getRowsData(previousData)}</tbody>
                        </table>
                     )}
                  </div>
               </div>
            </>
         )}
      </div>
   );
}
export default CustomPQRView
